import { GridRowId } from '@mui/x-data-grid-pro';
import { RootActions } from 'store/redux';
import { changeBaselineState, ChangeBaselineState } from '../states/changeBaselineState';
import { ChangeBaseLineActions } from 'store/actions/changeBaselineActions';

const changeBaselineReducer = (state = changeBaselineState, action: RootActions): ChangeBaselineState => {
  switch (action.type) {
    case ChangeBaseLineActions.LOAD_ORDER:
      return {
        ...state,
        sourceOrder: action.payload,
      };
    case ChangeBaseLineActions.LOAD_ORDER_BL:
      return {
        ...state,
        baseLineOrder: action.payload,
      };
    case ChangeBaseLineActions.SORT_TOTALWORKUNIT:
      return {
        ...state,
        sortBLtotalWorkunitModel: action.payload,
      };
    case ChangeBaseLineActions.INJECT_WORKUNITS:
      return {
        ...state,
        workunits: action.payload.workunits,
      };
    case ChangeBaseLineActions.INJECT_MONTHS:
      return {
        ...state,
        months: action.payload.months,
      };
    case ChangeBaseLineActions.INJECT_QUARTERS:
      return {
        ...state,
        quarters: action.payload.quarters,
      };
    case ChangeBaseLineActions.FILTER_TOTALWORKNUNIT_FLAG:
      return {
        ...state,
        filterTotalFlag: action.payload,
      };
    case ChangeBaseLineActions.INJECT_FILTER_TOTALWORKUNITS:
      return {
        ...state,
        filterTotalWorkunitData: action.payload.datas,
      };
    case ChangeBaseLineActions.INJECT_TOTALWORKUNITS:
      return {
        ...state,
        totalworkunitData: action.payload.datas,
        totalItems: action.payload.totalItems,
        totalPages: action.payload.totalPages,
        // currentPage: action.payload.currentPage,
      };
    case ChangeBaseLineActions.CHANGE_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      };
    case ChangeBaseLineActions.CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case ChangeBaseLineActions.LOAD_CHANGEBASELINE_CUSTOMERS:
      return {
        ...state,
        customers: action.payload,
      };
    case ChangeBaseLineActions.LOAD_DELIVERABLE_DM:
      return {
        ...state,
        deliveryManagers: action.payload,
      };
    case ChangeBaseLineActions.SELECT_BL_DELIVERABLES:
      return {
        ...state,
        selectedBLDeliverablesModel: action.payload,
      };
    case ChangeBaseLineActions.SELECT_BL_DELIVERABLES_LIST:
      return {
        ...state,
        selectedBLDeliverablesList: action.payload,
      };
    case ChangeBaseLineActions.SELECT_BL_ALL_DELIVERABLES:
      return {
        ...state,
        selectedBLAllDeliverables: action.payload,
      };

    case ChangeBaseLineActions.EXCLUDE_BL_DELIVERABLES_COUNT:
      return {
        ...state,
        excludedBLDeliverables: action.payload,
      };
    case ChangeBaseLineActions.CLEAR_CHANGE_BASELINE_STATE:
      return { ...changeBaselineState };

    case ChangeBaseLineActions.DISPLAY_FILTER_TAG:
      return {
        ...state,
        tagFilter: action.payload,
      };
    case ChangeBaseLineActions.SINGLE_WORUNIT_FLAG:
      return {
        ...state,
        singleWorkunitSave: action.payload,
      };
    case ChangeBaseLineActions.MULTIPLE_WORKUNIT_FLAG:
      return {
        ...state,
        multipleWorkunitSave: action.payload,
      };
    case ChangeBaseLineActions.EDIT_ORDER_BASELINE:
      return {
        ...state,
        editOrder: action.payload,
      };
    default:
      return state;
  }
};

export default changeBaselineReducer;
